<!-- <p>rpe-nstab works!</p> -->

<mat-tab-group [@.disabled]="true">

    <mat-tab>
        <ng-template mat-tab-label>
            M<sub>1</sub>
        </ng-template>

        <div class="content-center">
            <rpe-nsm1></rpe-nsm1>
        </div>

    </mat-tab>


    <mat-tab>
        <ng-template mat-tab-label>
            M<sub>2</sub>
        </ng-template>
        <div class="content-center">
            <rpe-nsm2></rpe-nsm2>
        </div>

    </mat-tab>


    <mat-tab>
        <ng-template mat-tab-label>
            p<sub>2</sub>/ p<sub>1</sub>
        </ng-template>

        <div class="content-center">
            <rpe-nsp2p1></rpe-nsp2p1>
        </div>
    </mat-tab>



    <mat-tab>
        <ng-template mat-tab-label>
            T<sub>2</sub>/ T<sub>1</sub>
        </ng-template>
        <div class="content-center">
            <rpe-nst2t1></rpe-nst2t1>
        </div>

    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>

            ΔV/a<sub>1</sub>
        </ng-template>
        <div class="content-center">
            <rpe-dva1></rpe-dva1>
        </div>
    </mat-tab>

    <!-- <mat-tab>
        <ng-template>
            V/a<sub>1</sub>
        </ng-template>
    </mat-tab> -->

</mat-tab-group>